import React from 'react';

import { ISvgIconProps } from '~/src/dash/components/icons/common';

export const ArrowDownPillIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='14'
      height='16'
      viewBox='0 0 14 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.7682 9.36C13.4142 8.936 12.7842 8.878 12.3602 9.232L8.00023 12.865V1C8.00023 0.448 7.55224 0 7.00024 0C6.44824 0 6.00024 0.448 6.00024 1V12.865L1.64023 9.232C1.21523 8.878 0.585235 8.936 0.232235 9.36C-0.121765 9.784 -0.0647651 10.415 0.360235 10.768L6.36023 15.768C6.40723 15.808 6.46323 15.827 6.51523 15.857C6.55623 15.881 6.59223 15.909 6.63723 15.927C6.75423 15.973 6.87624 16 7.00024 16C7.12424 16 7.24623 15.973 7.36323 15.927C7.40824 15.909 7.44423 15.881 7.48523 15.857C7.53723 15.827 7.59324 15.808 7.64023 15.768L13.6402 10.768C14.0642 10.415 14.1222 9.784 13.7682 9.36Z'
        fill={props.color}
      />
    </svg>
  );
};

export const ChannelsPillIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M10.6666 10.2C10.6666 10.5312 10.3679 10.8 9.99992 10.8H1.99992C1.63192 10.8 1.33325 10.5312 1.33325 10.2V4.20008C1.33325 3.86889 1.63192 3.60009 1.99992 3.60009H9.99992C10.3679 3.60009 10.6666 3.86889 10.6666 4.20008V10.2ZM10 2.40012H7.60933L9.138 1.02434C9.39867 0.78974 9.39867 0.410545 9.138 0.175948C8.87733 -0.0586493 8.456 -0.0586493 8.19533 0.175948L6 2.15172L3.80467 0.175948C3.544 -0.0586493 3.12267 -0.0586493 2.862 0.175948C2.60133 0.410545 2.60133 0.78974 2.862 1.02434L4.39067 2.40012H2C0.897333 2.40012 0 3.20771 0 4.2001V10.2C0 11.1924 0.897333 12 2 12H10C11.1027 12 12 11.1924 12 10.2V4.2001C12 3.20771 11.1027 2.40012 10 2.40012Z'
        fill={props.color}
      />
      <path
        d='M4.07718 8.6109L5.71531 7.04551C5.81427 6.95095 5.87196 6.82391 5.87558 6.69247C5.87921 6.56102 5.8285 6.4358 5.73467 6.34445C5.53929 6.15424 5.21376 6.15968 5.00768 6.3566L3.37322 7.91849C3.27426 8.01305 3.21658 8.14009 3.21295 8.27153C3.20932 8.40298 3.26004 8.52821 3.35386 8.61955C3.54783 8.80838 3.87054 8.80471 4.07718 8.6109Z'
        fill={props.color}
      />
      <path
        d='M4.97021 6.96049L6.27563 8.62159C6.35449 8.72193 6.47237 8.78736 6.60325 8.80339C6.73413 8.81942 6.8674 8.78476 6.97364 8.70709C7.19488 8.54534 7.24111 8.24475 7.07689 8.03578L5.77439 6.3784C5.69553 6.27806 5.57765 6.21262 5.44677 6.19659C5.3159 6.18056 5.18262 6.21523 5.07638 6.2929C4.85675 6.45347 4.8092 6.7513 4.97021 6.96049Z'
        fill={props.color}
      />
      <path
        d='M7.92202 6.3544L6.37004 7.92538C6.27629 8.02029 6.22466 8.1466 6.22661 8.27641C6.22856 8.40623 6.28393 8.52905 6.38044 8.61775C6.58142 8.80247 6.90269 8.79199 7.09793 8.59436L8.64644 7.02689C8.74019 6.93199 8.79181 6.80568 8.78986 6.67586C8.78791 6.54605 8.73255 6.42322 8.63604 6.33453C8.43652 6.15115 8.11795 6.15984 7.92202 6.3544Z'
        fill={props.color}
      />
    </svg>
  );
};

export const DataPillIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='12'
      height='14'
      viewBox='0 0 12 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        d='M6 0C4.42798 0 3.00298 0.275548 1.92708 0.756691C1.38905 0.997269 0.938542 1.28497 0.59372 1.64946C0.249018 2.01396 0 2.49274 0 3.02693V10.9729C0 11.5071 0.248908 11.98 0.59372 12.3446C0.938542 12.7091 1.38905 12.9968 1.92708 13.2374C3.00304 13.7185 4.42801 14 6 14C7.57199 14 8.99702 13.7185 10.0729 13.2374C10.611 12.9968 11.0615 12.7092 11.4063 12.3446C11.7511 11.9801 12 11.5073 12 10.9729V3.02693C12 2.49274 11.7511 2.01396 11.4063 1.64946C11.0615 1.28497 10.611 0.997266 10.0729 0.756691C8.99697 0.275541 7.57199 0 6 0ZM6 1.13521C7.46554 1.13521 8.79378 1.40614 9.70833 1.81511C10.1657 2.01966 10.5174 2.25919 10.7292 2.48311C10.941 2.70706 11.0001 2.88207 11.0001 3.0271C11.0001 3.172 10.9411 3.34119 10.7292 3.56514C10.5174 3.78909 10.1657 4.02876 9.70833 4.23315C8.79375 4.64211 7.46563 4.919 6 4.919C4.53446 4.919 3.20634 4.64213 2.29167 4.23315C1.83432 4.0286 1.48262 3.78906 1.2708 3.56514C1.05898 3.34119 0.999923 3.172 0.999923 3.0271C0.999923 2.8822 1.05887 2.70708 1.2708 2.48311C1.48263 2.25916 1.83432 2.0195 2.29167 1.81511C3.20625 1.40615 4.53449 1.13521 6 1.13521ZM1 4.7592C1.26937 4.96164 1.58 5.13609 1.92702 5.2913C3.00298 5.77245 4.42795 6.05393 5.99994 6.05393C7.57193 6.05393 8.99696 5.77245 10.0729 5.2913C10.42 5.1361 10.7305 4.96164 10.9999 4.7592V5.67559C10.9999 5.82049 10.9409 5.98967 10.729 6.21363C10.5172 6.43758 10.1655 6.67725 9.70814 6.88164C8.79355 7.29059 7.46543 7.56748 5.9998 7.56748C4.53427 7.56748 3.20614 7.29062 2.29147 6.88164C1.83412 6.67709 1.48242 6.43755 1.27061 6.21363C1.0589 5.98955 0.999958 5.82049 0.999958 5.67559L1 4.7592ZM1 7.40201C1.26937 7.60577 1.57851 7.78407 1.92702 7.94005C3.00298 8.4212 4.42795 8.70269 5.99994 8.70269C7.57193 8.70269 8.99696 8.4212 10.0729 7.94005C10.4215 7.7842 10.7305 7.60578 10.9999 7.40201V8.32434C10.9999 8.46925 10.9409 8.63843 10.729 8.86239C10.5172 9.08634 10.1655 9.326 9.70814 9.53039C8.79355 9.93935 7.46543 10.2162 5.9998 10.2162C4.53427 10.2162 3.20614 9.93937 2.29147 9.53039C1.83412 9.32584 1.48242 9.08631 1.27061 8.86239C1.05879 8.63847 0.999726 8.46924 0.999726 8.32434V7.40201H1ZM1 10.0506C1.26937 10.2544 1.57851 10.4327 1.92702 10.5886C3.00298 11.0698 4.42795 11.3513 5.99994 11.3513C7.57193 11.3513 8.99696 11.0698 10.0729 10.5886C10.4215 10.4328 10.7305 10.2544 10.9999 10.0506V10.9729C10.9999 11.1178 10.9409 11.287 10.729 11.511C10.5172 11.7349 10.1655 11.9746 9.70814 12.179C8.79355 12.5879 7.46543 12.8648 5.9998 12.8648C4.53427 12.8648 3.20614 12.588 2.29147 12.179C1.83412 11.9744 1.48242 11.7349 1.27061 11.511C1.05879 11.2871 0.999726 11.1178 0.999726 10.9729V10.0506H1Z'
        fill={props.color}
      />
    </svg>
  );
};

export const StatusPillIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M7.8002 6.57168C7.469 6.57168 7.2002 6.31568 7.2002 6.00025C7.2002 5.68482 7.469 5.42882 7.8002 5.42882C8.1314 5.42882 8.4002 5.68482 8.4002 6.00025C8.4002 6.31568 8.1314 6.57168 7.8002 6.57168M7.8 4.28559C6.8076 4.28559 6 5.05473 6 5.99988C6 6.94502 6.8076 7.71416 7.8 7.71416C8.7924 7.71416 9.6 6.94502 9.6 5.99988C9.6 5.05473 8.7924 4.28559 7.8 4.28559M7.79971 8.85751H4.19971C2.54551 8.85751 1.19971 7.5758 1.19971 6.00037C1.19971 4.42494 2.54551 3.14323 4.19971 3.14323H7.79971C9.45391 3.14323 10.7997 4.42494 10.7997 6.00037C10.7997 7.5758 9.45391 8.85751 7.79971 8.85751M7.8 2H4.2C1.8846 2 0 3.79486 0 6C0 8.20514 1.8846 10 4.2 10H7.8C10.1154 10 12 8.20514 12 6C12 3.79486 10.1154 2 7.8 2'
        fill={props.color}
      />
    </svg>
  );
};

export const BiddersPillIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        d='M9.23993 2.04036C9.11084 1.86606 8.95199 1.72753 8.77429 1.63431C8.59659 1.5411 8.40427 1.4954 8.21054 1.50037L1.26322 1.5069C0.568507 1.5069 0 2.07888 0 2.78604V9.21396C0 9.92112 0.568507 10.4931 1.26322 10.4931L8.21054 10.4996C8.40427 10.5046 8.59659 10.4589 8.77429 10.3657C8.95199 10.2725 9.11084 10.1339 9.23993 9.95964L12 6.00012L9.23993 2.04036ZM8.21054 9.21396H1.26322V2.78604H8.21054L10.4526 6.00012L8.21054 9.21396Z'
        fill={props.color}
      />
    </svg>
  );
};

export const TiersPillIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        d='M3.43159 7.85157H2.89067V3.18571C2.89067 3.08762 2.8149 3.0004 2.70676 3.0004H2.03596C1.93862 3.0004 1.85206 3.07674 1.85206 3.18571V7.85157H1.31114C1.05148 7.85157 0.910879 8.14593 1.06234 8.35308L2.12252 9.72665C2.25232 9.89015 2.49033 9.89015 2.60933 9.72665L3.66951 8.35308C3.84262 8.15681 3.69117 7.85157 3.43159 7.85157Z'
        fill={props.color}
      />
      <path
        d='M6.9907 8.10195C6.95825 8.06925 6.90414 8.04742 6.85004 8.04742H4.67554C4.55653 8.04742 4.46997 8.14552 4.46997 8.25457V9.64997C4.46997 9.75902 4.56732 9.85712 4.67554 9.85712H6.86086C6.91496 9.85712 6.9582 9.83529 7.00152 9.80259L7.79124 9.1049C7.88859 9.01767 7.88859 8.87593 7.79124 8.78879L6.9907 8.10195Z'
        fill={props.color}
      />
      <path
        d='M8.71083 5.58364C8.67838 5.55094 8.62427 5.52911 8.57016 5.52911H4.67554C4.55653 5.52911 4.46997 5.62721 4.46997 5.73626V7.13166C4.46997 7.24071 4.56732 7.33881 4.67554 7.33881H8.57016C8.62427 7.33881 8.66751 7.31698 8.71083 7.28428L9.50055 6.58659C9.5979 6.49936 9.5979 6.35761 9.50055 6.27048L8.71083 5.58364Z'
        fill={props.color}
      />
      <path
        d='M11.2207 3.76316L10.4201 3.05452C10.3877 3.02182 10.3336 3 10.2795 3L4.67554 3.00008C4.55653 3.00008 4.46997 3.09817 4.46997 3.20722V4.60262C4.46997 4.71167 4.56732 4.80977 4.67554 4.80977H10.2903C10.3444 4.80977 10.3876 4.78795 10.431 4.75525L11.2207 4.05755C11.3072 3.99207 11.3072 3.83946 11.2207 3.76319L11.2207 3.76316Z'
        fill={props.color}
      />
    </svg>
  );
};

export const TopSortPillIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M6.75004 10.8889L6.75004 2.94445L7.65004 3.92223C7.89829 4.19234 8.36854 4.24673 8.70004 4.04445C9.03154 3.84218 9.09829 3.45962 8.85004 3.1889L6.60004 0.744457C6.45979 0.591679 6.24004 0.501235 6.00679 0.500013C5.77204 0.498791 5.55079 0.585568 5.40754 0.736512L3.15754 3.09662C3.05104 3.20784 3.00004 3.33984 3.00004 3.47123C3.00004 3.65334 3.09979 3.83362 3.29029 3.95401C3.61654 4.16118 4.08829 4.1129 4.34254 3.84645L5.25004 2.89434L5.25004 10.8889C5.25004 11.2262 5.58529 11.5 6.00004 11.5C6.41479 11.5 6.75004 11.2262 6.75004 10.8889'
        fill={props.color}
      />
    </svg>
  );
};

export const TrendsPillIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        d='M10.3989 4.6991C10.4159 5.04882 10.7632 5.35208 11.1277 5.3356H13.5095L9.0179 9.14414L6.1359 6.93205C5.76529 6.59799 5.40638 6.61935 5.10273 6.82771L0.230532 10.8345C-0.0456043 11.0641 -0.0792486 11.5139 0.159842 11.7788C0.398932 12.0438 0.867921 12.076 1.14407 11.8466L5.57038 8.20505L8.38712 10.365C8.59494 10.73 9.1936 10.8089 9.49642 10.511L14.6079 6.18078V8.67459C14.6026 9.0274 14.9362 9.35187 15.3039 9.35187C15.6716 9.35187 16.0052 9.02742 15.9999 8.67459V4.6678C15.9999 4.31809 15.6684 4 15.3039 4H11.1277C10.7301 4.00326 10.3919 4.32395 10.3989 4.6991Z'
        fill={props.color}
      />
    </svg>
  );
};

export const DeviceTypePillIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.73316 0H10.2672C11.2232 0 12.0005 0.830667 12.0005 1.85133V10.1487C12.0005 11.1693 11.2232 12 10.2672 12H9.33382C8.96516 12 8.66716 11.702 8.66716 11.3333C8.66716 10.9647 8.96516 10.6667 9.33382 10.6667H10.2672C10.4838 10.6667 10.6672 10.4293 10.6672 10.1487V1.85133C10.6672 1.57067 10.4838 1.33333 10.2672 1.33333H1.73316C1.51649 1.33333 1.33382 1.57067 1.33382 1.85133V2.66667C1.33382 3.03533 1.03516 3.33333 0.667155 3.33333C0.298489 3.33333 0.000488562 3.03533 0.000488562 2.66667V1.85133C0.000488562 0.830667 0.777822 0 1.73316 0ZM0.00642183 8.11333C-0.0442448 7.74867 0.211089 7.412 0.575755 7.362C1.52242 7.23267 2.44642 7.54267 3.11842 8.214C4.00976 9.10667 4.25176 10.4733 3.71909 11.6153C3.60576 11.8573 3.36576 12 3.11442 12C3.01976 12 2.92376 11.98 2.83309 11.9373C2.49976 11.782 2.35509 11.3853 2.51042 11.0513C2.80709 10.416 2.67309 9.654 2.17576 9.15733C1.80109 8.78333 1.28509 8.612 0.757755 8.682C0.389089 8.73467 0.0564218 8.478 0.00642183 8.11333ZM0.575089 4.71807C0.210422 4.76873 -0.0442447 5.1054 0.00642194 5.47007C0.0570886 5.83407 0.392422 6.0894 0.758422 6.03807C2.01909 5.86607 3.25709 6.27807 4.15642 7.17673C5.19376 8.21473 5.58376 9.73607 5.17309 11.1474C5.07042 11.5007 5.27376 11.8707 5.62709 11.9734C5.68976 11.9914 5.75242 12.0001 5.81309 12.0001C6.10242 12.0001 6.36842 11.8114 6.45309 11.5194C6.99976 9.64207 6.48042 7.61673 5.09909 6.23407C3.90242 5.0374 2.25642 4.48407 0.575089 4.71807ZM0.000221848 10.6667C0.000221848 10.298 0.298222 10 0.666888 10C1.03556 10 1.33356 10.298 1.33356 10.6667C1.33356 11.0353 1.03556 11.3333 0.666888 11.3333C0.298222 11.3333 0.000221848 11.0353 0.000221848 10.6667Z'
        fill={props.color}
      />
    </svg>
  );
};

export const ClockPillIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M8.66732 6.45793H7.04232V4.83458C7.04232 4.53535 6.79965 4.29347 6.50065 4.29347C6.20165 4.29347 5.95898 4.53535 5.95898 4.83458V6.99905C5.95898 7.29828 6.20165 7.54016 6.50065 7.54016H8.66732C8.96686 7.54016 9.20898 7.29828 9.20898 6.99905C9.20898 6.69981 8.96686 6.45793 8.66732 6.45793ZM6.50065 11.328C4.11136 11.328 2.16732 9.38591 2.16732 6.99905C2.16732 4.61219 4.11136 2.67012 6.50065 2.67012C8.88994 2.67012 10.834 4.61219 10.834 6.99905C10.834 9.38591 8.88994 11.328 6.50065 11.328ZM6.50065 1.58789C3.5139 1.58789 1.08398 4.01534 1.08398 6.99905C1.08398 9.98276 3.5139 12.4102 6.50065 12.4102C9.4874 12.4102 11.9173 9.98276 11.9173 6.99905C11.9173 4.01534 9.4874 1.58789 6.50065 1.58789Z'
        fill={props.color}
      />
    </svg>
  );
};

export const RoutePillIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='12'
      height='11'
      viewBox='0 0 22 19'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        d='M18.6193 0.131593L20.8807 2.84933C20.922 2.8908 20.9548 2.94005 20.9771 2.99426C20.9995 3.04847 21.011 3.10659 21.011 3.16527C21.011 3.22396 20.9995 3.28207 20.9771 3.33628C20.9548 3.39049 20.922 3.43974 20.8807 3.48121L18.6193 6.19895C18.5574 6.26179 18.4783 6.30466 18.3921 6.32208C18.3059 6.3395 18.2164 6.33069 18.1352 6.29676C18.054 6.26284 17.9847 6.20534 17.9361 6.13162C17.8876 6.05789 17.862 5.97128 17.8626 5.88285V4.21985L13.1009 4.21985L8.7254 9.45409L13.1038 14.7799H17.8587V13.1169C17.8582 13.0285 17.884 12.942 17.9326 12.8684C17.9811 12.7948 18.0504 12.7374 18.1316 12.7035C18.2127 12.6696 18.3021 12.6607 18.3882 12.6781C18.4744 12.6954 18.5535 12.7381 18.6154 12.8008L20.881 15.5185C20.9629 15.6031 21.0087 15.7165 21.0087 15.8345C21.0087 15.9525 20.9629 16.0658 20.881 16.1504L18.6196 18.8682C18.5577 18.931 18.4786 18.9739 18.3924 18.9913C18.3062 19.0087 18.2168 18.9999 18.1356 18.966C18.0543 18.932 17.985 18.8745 17.9365 18.8008C17.8879 18.7271 17.8623 18.6405 17.8629 18.5521V16.8891H12.6122C12.4576 16.8887 12.3049 16.8542 12.1649 16.7882C12.0249 16.7221 11.9009 16.626 11.8018 16.5066L6.86547 10.5088L1.06112 10.5088C0.782604 10.5088 0.5155 10.3976 0.318562 10.1995C0.121625 10.0015 0.010987 9.73288 0.010987 9.4528C0.010987 9.17272 0.121625 8.90411 0.318562 8.70607C0.5155 8.50802 0.782604 8.39676 1.06112 8.39676L6.86965 8.39676L11.806 2.48891C11.9037 2.37031 12.0262 2.2749 12.1649 2.20952C12.3036 2.14413 12.4549 2.11038 12.608 2.11069L17.8587 2.11069V0.447694C17.8587 0.359085 17.8849 0.272473 17.9339 0.198823C17.9829 0.125172 18.0525 0.0677934 18.1339 0.0339495C18.2153 0.000105641 18.3049 -0.00868174 18.3913 0.00870004C18.4777 0.0260818 18.5571 0.0688499 18.6193 0.131593V0.131593Z'
        fill={props.color}
      />
    </svg>
  );
};

export const DealsPillIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M2.20802 9.43988C1.94274 9.73043 1.50087 9.80868 1.14471 9.60491L0.428574 9.19442C0.0188569 8.95959 -0.121691 8.43936 0.114882 8.03227L2.07599 4.66074C2.31257 4.25407 2.83709 4.11456 3.24683 4.34938L3.96297 4.75987C4.32123 4.96535 4.4738 5.38855 4.34829 5.76382L4.87884 6.08923L5.90571 6.32025L5.99439 6.22539C6.07628 6.13737 6.19155 6.08752 6.31237 6.08838L7.287 6.09559L7.68219 5.79488C7.53133 5.41033 7.68181 4.96366 8.05289 4.75097L8.75316 4.3494C9.16288 4.11458 9.6874 4.25407 9.924 4.66076L11.8851 8.03229C12.1217 8.43935 11.9812 8.95959 11.5714 9.19443L10.8712 9.596C10.5682 9.76958 10.2026 9.73853 9.93691 9.54625L9.5533 9.88999L8.93272 10.7505C8.91091 10.8977 8.86327 11.0419 8.78961 11.1763C8.58565 11.5477 8.20978 11.7948 7.78591 11.8365L6.20707 11.9909C5.85818 12.0249 5.50594 11.9637 5.18958 11.8131L4.13009 11.3094C3.86739 11.1844 3.66679 10.9594 3.57334 10.6854L3.41301 10.2166C3.38986 10.1477 3.34183 10.0899 3.27841 10.0537L2.20783 9.4398L2.20802 9.43988ZM3.93476 6.51027L2.65334 8.71289L3.70717 9.317C3.95063 9.45649 4.13489 9.67943 4.22528 9.94407L4.38513 10.4129C4.40446 10.4698 4.44598 10.5163 4.50089 10.5422L5.55988 11.0458C5.73514 11.1292 5.92973 11.1632 6.12305 11.1445L7.70151 10.9896C7.84338 10.976 7.96899 10.893 8.03709 10.7692C8.1052 10.645 8.10693 10.4957 8.04178 10.3697L7.11172 8.57284L6.12897 9.14627C5.78008 9.34956 5.34891 9.35602 4.9941 9.16289C4.63929 8.97022 4.41295 8.6056 4.39792 8.20452C4.39189 8.04205 4.45063 7.88377 4.5616 7.76469L5.23451 7.04152L4.61949 6.90327C4.57319 6.89263 4.52909 6.87478 4.48882 6.85009L3.93463 6.51017L3.93476 6.51027ZM8.10638 6.54426L7.69196 6.85951C7.6161 6.91734 7.52311 6.94801 7.42793 6.94753L6.4954 6.94032L5.27015 8.25733C5.29368 8.32455 5.3417 8.382 5.40599 8.41723C5.49639 8.46613 5.60612 8.46442 5.6949 8.41296L7.06844 7.61154C7.17042 7.55239 7.2922 7.5371 7.40528 7.56986C7.51845 7.60214 7.61315 7.68 7.66673 7.78379L8.64949 9.68191L8.8831 9.35774C8.90109 9.33267 8.92165 9.31007 8.94442 9.28928L9.44331 8.84262L8.1066 6.54426L8.10638 6.54426ZM0.8571 8.45767L1.57324 8.86816L3.53434 5.49663L2.81821 5.08614L0.8571 8.45767ZM8.48132 5.48771L10.4424 8.859L11.1427 8.45782L9.18159 5.08629L8.48132 5.48771Z'
        fill={props.color}
      />
      <path
        d='M6.6735 2.68348V0.497888C6.6735 0.36586 6.6228 0.239163 6.53256 0.14581C6.44232 0.0524575 6.31985 0 6.19222 0C5.92644 0 5.71094 0.22294 5.71094 0.497888V2.67858C5.71094 2.81061 5.76164 2.93731 5.85188 3.03066C5.94213 3.12401 6.0646 3.17647 6.19222 3.17647C6.45607 3.17647 6.67092 2.95665 6.6735 2.68348Z'
        fill={props.color}
      />
      <path
        d='M3.00494 1.14926C2.90937 1.22565 2.84573 1.34012 2.82817 1.46737C2.81062 1.59482 2.84034 1.72444 2.91097 1.82788L3.93447 3.33053C4.01787 3.45431 4.15055 3.5281 4.292 3.52918C4.38876 3.52918 4.48274 3.49521 4.56015 3.43224C4.6597 3.35563 4.72594 3.23835 4.7437 3.10743C4.76126 2.97651 4.72894 2.84342 4.65392 2.73912L3.62164 1.25098C3.47559 1.04129 3.20185 0.996266 3.00494 1.14926Z'
        fill={props.color}
      />
      <path
        d='M9.11243 1.19603L7.78928 2.58217C7.59992 2.78137 7.58346 3.12296 7.75243 3.34586C7.92058 3.56971 8.2114 3.59172 8.4024 3.39445L9.72555 2.0083C9.91634 1.8108 9.93487 1.46921 9.76713 1.24486C9.68624 1.1356 9.5714 1.06887 9.44832 1.05969C9.32545 1.0505 9.20443 1.09957 9.11243 1.19603Z'
        fill={props.color}
      />
    </svg>
  );
};

export const DataLinePillIcon = (props: ISvgIconProps) => {
  return (
    <svg
      width='12'
      height='12'
      viewBox='0 0 12 12'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      style={props.style}
    >
      <path
        d='M9.99488 2.50003C9.84201 2.49898 9.69099 2.53623 9.55362 2.60887C9.41626 2.68151 9.29627 2.78758 9.20305 2.91877C9.10983 3.04997 9.04589 3.20274 9.01625 3.36514C8.9866 3.52753 8.99204 3.69516 9.03216 3.8549L6.75774 6.31874C6.59486 6.26742 6.42185 6.26742 6.25897 6.31874L5.48122 5.47652C5.51682 5.32763 5.52275 5.17224 5.49862 5.02067C5.4745 4.8691 5.42086 4.72483 5.34129 4.59744C5.26171 4.47004 5.15801 4.36244 5.03708 4.28178C4.91615 4.20112 4.78075 4.14925 4.63988 4.12962C4.49901 4.10998 4.3559 4.12303 4.22005 4.1679C4.08419 4.21276 3.95871 4.28842 3.85194 4.38983C3.74516 4.49125 3.65954 4.61611 3.60075 4.75612C3.54196 4.89613 3.51136 5.04809 3.51098 5.20189C3.5117 5.29468 3.52346 5.38699 3.54598 5.47652L2.2681 6.85885C2.05413 6.79633 1.82709 6.81206 1.62223 6.90361C1.41737 6.99516 1.24616 7.15741 1.1352 7.36514C1.02423 7.57288 0.979712 7.81448 1.00856 8.05243C1.03741 8.29037 1.13801 8.51134 1.29474 8.68102C1.45146 8.85069 1.65555 8.95958 1.87528 8.99076C2.09502 9.02195 2.31812 8.97368 2.50993 8.85347C2.70174 8.73325 2.85153 8.54782 2.93602 8.32596C3.02052 8.1041 3.03499 7.85823 2.9772 7.62655L4.25407 6.24385C4.41695 6.29517 4.58996 6.29517 4.75284 6.24385L5.53059 7.08607C5.49024 7.24707 5.4847 7.41598 5.51439 7.57968C5.54408 7.74338 5.60821 7.89747 5.7018 8.02999C5.79539 8.16251 5.91593 8.26989 6.05405 8.3438C6.19216 8.4177 6.34415 8.45615 6.49821 8.45615C6.65227 8.45615 6.80426 8.4177 6.94238 8.3438C7.0805 8.26989 7.20103 8.16251 7.29462 8.02999C7.38821 7.89747 7.45234 7.74338 7.48204 7.57968C7.51173 7.41598 7.50618 7.24707 7.46583 7.08607L9.74126 4.62277C9.87874 4.66316 10.0226 4.6712 10.1632 4.64634C10.3038 4.62149 10.4378 4.56432 10.5563 4.47867C10.6748 4.39303 10.7749 4.28091 10.85 4.14984C10.9252 4.01878 10.9735 3.87181 10.9918 3.71883C11.01 3.56585 10.9978 3.41041 10.956 3.26296C10.9142 3.11551 10.8437 2.97947 10.7492 2.864C10.6548 2.74853 10.5386 2.6563 10.4085 2.59352C10.2783 2.53074 10.1373 2.49886 9.99488 2.50003Z'
        fill={props.color}
      />
    </svg>
  );
};

// FOR COPY REFERENCE ONLY
// export const PillIcon = (props: ISvgIconProps) => {
//   return (
//     <svg fill={props.color} style={props.style}></svg>
//   );
// };
